/**
 * Claude LLM adapter — STUB.
 * Must fulfill LLMPort (see /domain/ports/LLMPort.js).
 */
export function createClaudeLLM(/* {model, apiKey} */) {
  return {
    async status() { return { vendor: "claude", model: "sonnet-4.5", status: "not_configured" }; },
    async generatePlay() { throw new Error("CLAUDE_LLM_NOT_IMPLEMENTED"); },
    async regeneratePlay() { throw new Error("CLAUDE_LLM_NOT_IMPLEMENTED"); },
  };
}
